"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockCustomMenuPrice = void 0;
var mockCustomMenuPrice = {
  customTicketId: 483679,
  menuItems: [{
    calories: 2170,
    imageName: null,
    imageUrl: null,
    imageUUID: null,
    itemDescription: 'Pizza: Round (2000 Cal)<br/>Right: Crispy Chicken (170 Cal)',
    itemId: 102000,
    itemName: 'Custom Round',
    itemNameWithCalories: 'Custom Round (2170 Cal)',
    menuItemCode: 'MTO-14CP',
    price: 6.99,
    secondsUntilUnavailable: 0,
    selectedCustomOptions: [{
      id: 'B',
      options: [{
        isSelected: true,
        optionId: 1,
        value: 'Normal Bake'
      }],
      title: 'Bake'
    }, {
      id: 'C',
      options: [{
        isSelected: true,
        optionId: 1,
        value: 'Cheese'
      }],
      title: 'Cheese'
    }, {
      id: 'S',
      options: [{
        isSelected: true,
        optionId: 2,
        value: 'Normal Sauce'
      }],
      title: 'Sauce'
    }, {
      id: 'CO',
      options: [{
        isSelected: true,
        optionId: 1,
        value: 'Standard Cut'
      }],
      title: 'Cut Option'
    }],
    selectedToppings: [{
      left: 0,
      right: 2,
      toppingCode: 'TOP-CCB'
    }],
    sortOrder: 0,
    toppingPrice: 0
  }],
  succeeded: true
};
exports.mockCustomMenuPrice = mockCustomMenuPrice;